import PosSelect from './PosSelect';
import { POS_SALE_STATUS_FILTERS } from '../constants/posConst';
import '../css/Pos.css';

/**
 * The filter row over the Sales preview table: which sales to list
 * (Completed, Cancelled/Deleted or All) and two search boxes.
 *
 * The order id gets a box of its own because it is copied off a receipt and
 * pasted whole; mixing it into the free-text search would let a short id
 * fragment also match item names.
 *
 * Controlled — the Sales screen owns the values, since they decide its paging.
 *
 * @param {object} props
 * @param {string} props.status - a POS_SALE_STATUS_* value
 * @param {(status: string) => void} props.onStatusChange
 * @param {string} props.orderId
 * @param {(value: string) => void} props.onOrderIdChange
 * @param {string} props.search
 * @param {(value: string) => void} props.onSearchChange
 * @returns {JSX.Element}
 */
function PosSaleRecordFilters({ status, onStatusChange, orderId, onOrderIdChange, search, onSearchChange }) {
  return (
    <div className="pos-records-filters">
      <PosSelect
        className="pos-records-status"
        label="Status"
        options={POS_SALE_STATUS_FILTERS}
        value={status}
        onChange={onStatusChange}
      />
      <div className="pos-search pos-records-search-id">
        <input
          type="search"
          value={orderId}
          onChange={(e) => onOrderIdChange(e.target.value)}
          placeholder="Search order ID"
          aria-label="Search by order ID"
        />
      </div>
      <div className="pos-search pos-records-search">
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search item, cashier or reason"
          aria-label="Search by item, cashier, payment or reason"
        />
      </div>
    </div>
  );
}

export default PosSaleRecordFilters;
